import { useEffect, useState } from 'react';
import Modal from "../shared/Modal";
import "./FirstPublishModal.css";
import config from "environment";
import { useSelector } from 'react-redux';
import { selectEditingForm } from '../../redux/features/appData';
import { FormExtended } from 'effno-core';
import { handleCopyText } from '../shared/uiHelpers';
import { useNavigate } from 'react-router-dom';
import { apiGetForm } from '../../services/FormService';

const clientUrl = config.clientUrl;

type FirstPublishModalProps = {
    isOpen: boolean;
    onClose: () => void;
    form: FormExtended | undefined
}

export const FirstPublishModal = ({isOpen, onClose, form} : FirstPublishModalProps) => {

    const navigate = useNavigate();
    
    const editingForm = useSelector(selectEditingForm);

    const [publicLink, setPublicLink] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (form && !publicLink) {
            (async () => {
                if (form.publishedVersionId) {
                    const publishedForm = await apiGetForm(form.publishedVersionId);
                    if (publishedForm) {
                        setPublicLink(publishedForm.publicLink);
                    }
                }
            })()
        }
    }, [form]);

    const getShareURL = () => {
        return clientUrl + "/form/" + publicLink;
    }

    const handleCopyLink = async () => {
        if (!form) {
            return;
        }

        await handleCopyText(getShareURL());
    }

    const handleOpenLink = () => {
        if (!form) {
            return;
        }

        window.open(getShareURL(), "_blank");
    }

    const handleGoToShare = () => {
        navigate(`/share/${form?.publishedVersionId}`)
    }

    console.log("[FirstPublishModal] form", form);

    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={onClose}
            canClose={true}
            allowClickout={true}
        >
            <div className="first-publish-container">
                <div className="modal-title">
                    Congratulations
                </div>

                <div 
                    className="form-share-content"  
                >
                    <span>
                        Your form is now published and ready to be shared with the world! 
                        Copy this link to share your form on social media, messaging apps or via email. 
                        Visit the {<a onClick={handleGoToShare}>Share</a>} menu to see all sharing options.</span>
                </div>
                <div 
                    className="form-share-link"
                    onClick={handleCopyLink}
                >
                    <input
                        type="text"
                        value={getShareURL()}
                        disabled={true}
                        style={{pointerEvents: "none"}}
                    />
                </div>
                <div className="form-share-button">
                    <button
                        className="button-cancel"
                        onClick={handleCopyLink}
                    >
                        Copy
                    </button>
                    <button
                        className="button-save"
                        onClick={handleOpenLink}
                    >
                        Go To Form
                    </button>
                </div>

            </div>
        </Modal>
    )
};